import type { Dispatch, ReactElement, ReactNode, SetStateAction } from 'react';

import { Button, ButtonType } from '@components/Button';
import { Icons } from '@components/Icons/Icons';
import { Modal } from '@components/Modal/Modal';

export function InformationAlert({
  title = 'Info',
  show,
  setShow,
  children,
}: {
  title?: string;
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  children?: ReactNode;
}): ReactElement {
  const close = () => setShow(false);

  return (
    <Modal show={show} setShow={setShow} className="dark:bg-grey-darkest">
      <section className="flex flex-col items-center justify-center">
        <Icons.Info.Circle size="80px" color="hsl(190, 98%, 37%)" />
        <h2 className="mt-4">{title}</h2>
        <div className="my-4 flex items-center justify-evenly gap-4">
          {children}
        </div>
        <Button type={ButtonType.button} onClick={close}>
          Ok
        </Button>
      </section>
    </Modal>
  );
}
